<script setup lang="ts">
import columnGrip from "~/assets/icons/column-grip.svg"

const { sortedContents, onTableViewMounted, onTableViewUnmounted, onUpdatedViewModeSettings } = useTableView()
const { state: viewModeState } = useViewMode()
const { collectionTableDraggerClass } = useGlobals()
const { y: gripY } = useMouse()
const { currentRootFolder } = useNavigation()

const tableSettings = computed(() => viewModeState.value.current.tableView)

onMounted(() => onTableViewMounted())
onUnmounted(() => onTableViewUnmounted())
watch(() => viewModeState.value.current, onUpdatedViewModeSettings)
</script>

<template>
  <div class="table-screen">
    <div class="nav-spacer" />
    <div class="notes-container">
      <collection-folder-notes
        v-if="currentRootFolder"
        :key="currentRootFolder.id"
        :folder="currentRootFolder.asStatic()"
      />
    </div>
    <collection-table-header />
    <collection-scroll-container vertical class="table-list">
      <collection-table-file
        v-for="file in sortedContents"
        :key="file.id"
        :file-id="file.id"
      />
      <div class="dividers">
        <div
          v-for="width, index in tableSettings.widths"
          :key="index"
          :data-column-index="index"
          :style="{ marginLeft: px(width) }"
          :class="[collectionTableDraggerClass]"
          class="group divider-container"
        >
          <div class="divider" />
          <column-grip class="grip" :style="{ top: px(gripY) }" />
        </div>
      </div>
    </collection-scroll-container>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.table-screen
  @apply w-full max-h-screen overflow-hidden flex flex-col

.nav-spacer
  @apply pointer-events-none w-full flex-none h-[#{$nav-h-default}]

.notes-container
  @apply px-[#{$page-icon-p-main}] py-1

.table-header
  @apply flex-none

.table-list
  @apply relative flex flex-col gap-[#{$page-table-gap-items}]
  @apply h-full overflow-auto px-[#{$page-table-p-main}] py-[#{$page-table-gap-items}]

.dividers
  @apply absolute left-0 right-0 top-0 bottom-0 pointer-events-none

.divider-container
  @apply absolute h-full w-2 px-0.75 top-0 bottom-0 -right-1 z-gesture-overlay-layer hover:cursor-none pointer-events-auto

.divider
  @apply h-full w-full bg-$global-blue-primary opacity-0 group-hover:opacity-100

.grip
  @apply absolute w-3.5 h-7 -my-3.5 text-$global-blue-primary -right-0.75 opacity-0 group-hover:opacity-100
</style>
